import { MenuService } from "@/client";
import { useQuery } from "@tanstack/react-query";

const navigationQueryKey = (congressId?: string) => {
  return ["navigation", congressId ? congressId : "society"] as const;
};

function useNavigations(congressId?: string) {
  return useQuery({
    queryKey: navigationQueryKey(congressId),
    queryFn: () => MenuService.getAllMenuForCongressId({ congressId }),
  });
}

export { navigationQueryKey, useNavigations };
